/** @fileoverview list_user_analytics_views の共通定数 */

/** ツール名（単一参照点） */
export const LIST_USER_ANALYTICS_VIEWS_NAME =
  "list_user_analytics_views" as const;

/** LLM へ提示する説明文 */
export const LIST_USER_ANALYTICS_VIEWS_DESC = `Lists User Analytics views for a project.

Use when a user asks to list or choose User Analytics views for a given project and to understand each view's filter conditions (e.g., URL/URL group filters, titles, devices, OS, browsers, sources/mediums/terms/contents/campaigns, events, user/session ID filters, navigation flag, page count ranges, and visited page conditions).

Input:
- 'projectId' (required): ID of the User Analytics project.

Notes:
- Read-only; does not create, update, or delete anything.
- Excludes default date range because it is not meaningful for AI reasoning.
- Returns: { userAnalyticsId, views: [{ id, name, description, visitedPage, visitedPageFilterType, firstPageLocationFilterType, firstPageLocationURL, firstPageLocationURLGroupIDs, firstPageTitle, firstPageTitleFilterType, secondPageLocationFilterType, secondPageLocationURL, secondPageLocationURLGroupIDs, secondPageTitle, secondPageTitleFilterType, os, devices, browsers, defaultChannelGroup, sources, mediums, terms, contents, campaigns, campaignsFilterType, events, eventsNotIn, userPseudoId, userPseudoIdFilterType, sessionId, sessionIdFilterType, expVariantString, isSessionWithNavigation, pageLocationCount: { min, max }, gaSessionNumber: { min, max } }] }.`;
